<template>
    <v-layout
        v-if="getUserUtil"
        v-resize="onResize"
        class="table-wrapper mx-auto"
    >
        <v-container>
            <div style="background-color: white; padding: 3px; border-radius: 5px;">
                <v-alert
                    color="teal darken-3"
                    outlined
                    style="margin: 0;"
                    type="info"
                >
                    <span>Note: The information reported on this page is not displayed in real time, and still subject to succeeding updates.</span>
                </v-alert>
            </div>
            <br>
            <!-- DATA TABLE -->
            <v-data-table
                :headers="headers"
                :items="getUserUtil"
                :items-per-page="10"
                class="elevation-10"
                :footer-props="footer_props"
                :class="{ mobile: isMobile }"
            >
                <template #item="{ item }">
                    <!-- IF Desktop view -->
                    <TblRowDsktpView
                        v-if="item.BILL_T != null"
                        :is-mobile="isMobile"
                        :table-items="item"
                    />

                    <!-- IF MOBILE VIEW -->
                    <TblRowMblView
                        v-if="item.BILL_T != null"
                        :is-mobile="isMobile"
                        :table-items="item"
                    />

                    <tr v-else>
                        <td :colspan="headers.length" class="text-center">
                            <h1>No Utilizations</h1>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-container>
    </v-layout>
</template>

<script>
import TblRowDsktpView from '../TblRows/TblRowDsktpView.vue'
import TblRowMblView from '../TblRows/TblRowMblView.vue'

export default {
    components: { TblRowDsktpView, TblRowMblView },
    props: ['getUserUtil'],
    data: () => ({
        // Models
        isMobile: false,
        // Data Table properties
        footer_props: {
            'items-per-page-options': [10]
        },
        headers: [
            {
                text: 'Admission Date',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Release Date',
                align: 'center',
                sortable: false,
                class: 'teal--text'
            },
            {
                text: 'Availment Type',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Hospital/Clinic Name',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Doctor Name',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },

            {
                text: 'Hospital Bill Fee',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Professional Fee',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },

            {
                text: 'Diagnosis',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            }
            // {
            //   text: "Procedure",
            //   sortable: false,
            //   align: "center",
            //   class: "teal--text",
            // },
        ]
    }),
    methods: {
        onResize() {
            if (window.innerWidth < 968) {
                this.isMobile = true
            } else {
                this.isMobile = false
            }
        }
    }
}
</script>

<style scoped>
.mobile {
  color: #333;
}

.table-wrapper {
  width: 95%;
}

h1 {
    font-size: 18px;
}
@media (max-width: 599px) {
  .table-wrapper {
    width: 95%;
  }
}
@media (min-width: 599px) and (max-width: 968px) {
  .table-wrapper {
    width: 80%;
  }
}
</style>
